import * as yup from 'yup';

export const transformNaNTo = (defaultValue) => (value) =>
  Number.isNaN(value) ? defaultValue : value;

// Borrowed from: https://github.com/jquense/yup/issues/298#issuecomment-508346424
// Modified to allow default value.
export function defaultableNumber(
  defaultValue,
  typeErrorMessage = 'Invalid number',
) {
  return yup
    .number()
    .transform(function nullNumberTransform(value, originalValue) {
      if (this.isType(value)) return value;
      if (!originalValue || !originalValue.trim()) {
        return defaultValue;
      }
      // Return the invalid original value
      return originalValue;
    })
    .nullable(true)
    .typeError(typeErrorMessage);
}

export function nullableNumber(typeErrorMessage) {
  return defaultableNumber(null, typeErrorMessage);
}
